export default function isMobile () {
  return navigator.userAgent.match(/Android|iPhone|iPad/i)
}
